import useAnalyticsContext from '@client/hooks/useAnalyticsContext';
import AnalyticsConstants from '@constants/analytics';
import { useCallback } from 'react';
import { PRICING_DETAILS_PRODUCT_AREA } from './trackingConstants';

export const useTrackSaveNewEstimate = () => {
	const { track } = useAnalyticsContext();

	return useCallback(() => {
		track({
			event: AnalyticsConstants.BUTTON_CLICKED,
			properties: {
				product_area: PRICING_DETAILS_PRODUCT_AREA,
				button_action: 'Save new estimate',
				location: 'Side screen estimate',
			},
		});
	}, [track]);
};
